import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';
import { ProfileService } from '../../core/services/profile.service';
import { LogCategory, LoggerService, LogType, LogWidget } from '../../core/services/logger.service';
import { IWidgetComponent } from '../../shared/widget/i-widget-component';
import { Widget } from '../../shared/widget/widget';
import { HttpClient } from '@angular/common/http';
import { CalendarService, AgendaCalendar } from '../../services/calendar.service';


@Component({
    selector: 'agenda',
    templateUrl: './agenda.component.html',
    styleUrls: ['./agenda.component.scss'],
    standalone: false
})
export class AgendaComponent implements OnInit, OnDestroy, IWidgetComponent {
    public data: Widget;
    //public _calendar$: Observable<any> = null;
    public agendaCalendar;

    @HostBinding('class')
    get size(): string {
        var widgetSize = 'col-md-' + this.data.Size.toString();

        switch (this.data.Size) {
            case 4: {
                widgetSize += ' widget-small';
                break;
            }
            case 6: {
                widgetSize += ' widget-medium';
                break;
            }
            case 12: {
                widgetSize += ' widget-large';
                break;
            }
        }

        return widgetSize;
    }

    public dayMessage: string = '';

    constructor(
        private logger: LoggerService,
        private http: HttpClient, 
        public profileService: ProfileService,
        public cal: CalendarService,
    ) {
        this.log("constructor", null, LogCategory.Constructor);
        //this.getCurrentMessage();
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Widget, LogWidget.Agenda, category);
    }

    ngOnInit() {
        this.log("ngOnInit", null, LogCategory.Init);
        this.agendaCalendar = AgendaCalendar.getInstance();
                         
    }

    ngOnDestroy() {
        this.log("ngOnDestroy", "", LogCategory.Destroy);
    }
   
}

